import { MIconLibrary } from '@motadata/ui'

export const addIcons = (...icons) => MIconLibrary.add(...icons)

import('./regular').then((i) => addIcons(...(i.default || i)))
import('./light').then((i) => addIcons(...(i.default || i)))
import('./duotone').then((i) => addIcons(...(i.default || i)))
import('./solid').then((i) => addIcons(...(i.default || i)))
import('./custom').then((i) => addIcons(...(i.default || i)))
import('./workflow').then((i) => addIcons(...(i.default || i)))
